import { useEffect, useState } from 'react';
import * as authApi from '../services/api/authApi';

export default function useRegistrationStatus() {
    const [registrationEnabled, setRegistrationEnabled] = useState(true);

    useEffect(() => {
        authApi.fetchRegistrationStatus()
            .then(data => setRegistrationEnabled(data.enabled))
            .catch(() => {});
    }, []);

    return registrationEnabled;
}
